module.exports = __webpack_public_path__ + "static/logo_black-23f9bf625bc2ed90c216c12277ebe13b.png";